<template>
  <div>
    <h3>{{ terms.header }}</h3>
    <v-layout row align-center justify-start>
      <v-checkbox
        class="shrink"
        color="rgb(135, 0, 0)"
        v-on:click.native="$store.commit('updateForm', { key: 'terms', value: true })"
        :disabled="$store.state.form.terms"
      ></v-checkbox>
      <v-dialog
        v-model="termDialog"
        width="800"
      >
        <div slot="activator">{{ terms.content1 }} <span class="terms">{{ terms.content2 }}</span></div>
        <v-card>
          <v-card-title class="headline grey lighten-2">Terms and Conditions</v-card-title>
          <v-card-text>
            <p v-for="(para, idx) in terms.full" :key="idx">
              {{ para }}
            </p>
            <h2>{{ terms.subsection.subheader }}</h2>
            <p v-for="(para, idx) in terms.subsection.text" :key="idx">
              {{ para }}
            </p>
            <h4>{{ terms.subsection.subtitle1 }}</h4>
            <p v-for="(para, idx) in terms.subsection.subtext1" :key="idx">
              {{ para }}
            </p>
            <h4>{{ terms.subsection.subtitle2 }}</h4>
            <p v-for="(para, idx) in terms.subsection.subtext2" :key="idx">
              {{ para }}
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'LayoutTerms',
  props: {
    lang: String,
    terms: Object
  },
  data () {
    return {
      termDialog: false
    }
  }
}
</script>

<style scoped>
.terms {
  color: rgb(135, 0, 0);
}
.terms:hover {
  cursor: pointer;
}
</style>
